import {
  PaywallFeature,
  type PaywallFeatureState,
  type EntitlementFeatureBody,
  type PaywallFeatureStateFromEntitlement,
} from '@canvas/paywall-types';

export const ALL_RELEASED_PAYWALL_FEATURES: readonly PaywallFeature[] =
  Object.values(PaywallFeature);

export const EMPTY_RELEASED_PAYWALL_FEATURES: readonly PaywallFeature[] = [];

/**
 * Mocks an HTTP response that includes entitlement features in it as if all
 * features were ON
 */

export const unlockAllPaywallsResponseMock = {
  whiteboards: Object.fromEntries(
    Object.values(PaywallFeature).map((key) => [key, { isEntitled: true }]),
  ),
} as EntitlementFeatureBody;

/**
 * Mocks an HTTP response that includes entitlement features in it as if all
 * features were OFF
 */
export const lockAllPaywallsResponseMock = {
  whiteboards: Object.fromEntries(
    Object.values(PaywallFeature).map((key) => [key, { isEntitled: false }]),
  ),
} as EntitlementFeatureBody;

export const missingFeatureKeysResponseMock = {
  whiteboards: {
    [PaywallFeature.SMART_CONNECTORS]: { isEntitled: true },
  },
} satisfies EntitlementFeatureBody;

export const missingFeatureContentResponseMock = {
  whiteboards: {
    ...unlockAllPaywallsResponseMock.whiteboards,
    [PaywallFeature.SMART_CONNECTORS]: {},
  },
} satisfies EntitlementFeatureBody;

export const unknownFeaturesResponseMock = {
  whiteboards: {
    ...unlockAllPaywallsResponseMock.whiteboards,
    ['unknown' as PaywallFeature]: { isEntitled: true },
  },
} satisfies EntitlementFeatureBody;

/**
 * Mocks the internal Canvas paywall state as if all features were ON
 */
export const unlockAllPaywallsStateMock = Object.fromEntries(
  Object.values(PaywallFeature).map((key) => [key, { isEntitled: true }]),
) as PaywallFeatureState;

/**
 * Mocks the internal Canvas paywall state as if all features were OFF
 */

export const lockAllPaywallsStateMock = Object.fromEntries(
  Object.values(PaywallFeature).map((key) => [key, { isEntitled: false }]),
) as PaywallFeatureState;

export const missingFeatureKeysStateMock = {
  [PaywallFeature.SMART_CONNECTORS]: { isEntitled: true },
} satisfies PaywallFeatureStateFromEntitlement;

export const missingFeatureContentStateMock = {
  ...unlockAllPaywallsStateMock,
  [PaywallFeature.SMART_CONNECTORS]: {},
} satisfies PaywallFeatureStateFromEntitlement;
